import { Button, Text } from '@wework/dieter-ui'
import React from 'react'

export default function InternalRoomsDrawerFooter({
  onClick,
  selectionLength,
}) {
  return (
    <div
      style={{
        width: '100%',
        marginTop: 24,
        display: 'flex',
        position: 'fixed',
        bottom: '0%',
        zIndex: 9999,
        padding: 24,
        backgroundColor: 'white',
        left: '0%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Text size="small">{selectionLength} internal room</Text>
      <Button variant="contained" primary size="small" onClick={onClick}>
        Update
      </Button>
    </div>
  )
}
